/* eslint-disable react/destructuring-assignment */
import { useContext, useMemo } from 'react';
import { getWithdrawLedgerConfigFromProps } from '../helpers';
import type { MoonPayWithdrawLedgerProps } from '../types';
import { MoonPayContext } from './MoonPayProvider';
import { MoonPayWidget } from './MoonPayWidget';

export function MoonPayWithdrawLedgerWidget(props: MoonPayWithdrawLedgerProps) {
  const { apiKey, environment } = useContext(MoonPayContext);

  const config = useMemo(
    () =>
      getWithdrawLedgerConfigFromProps({
        props,
        apiKey,
        environment,
        debug: false,
        signature: props.signature || '',
      }),
    [props, apiKey, environment],
  );

  return (
    <MoonPayWidget
      config={config}
      visible={props.visible}
      onUrlSignatureRequested={props.onUrlSignatureRequested}
      className={props.className}
      style={props.style}
    />
  );
}
